var option_default = {
  "option": "z5-m0",
  "user_choice": "T4Yyr",
  "check": "FzyU6",
  "image": "nw6Ym",
  "input": "fJdsT",
  "title": "gl00X",
  "centered": "JgaW5",
  "with_result": "EePSI",
  "list": "_8achE",
  "with_image": "_-5MkS",
  "progress": "t-ZZb",
  "progress_value": "_8ZOHC",
  "label": "_3NzGe",
  "cta": "YHk-9",
  "adornment_icon": "rdi7H",
  "remove": "ABz8k",
  "removeButton": "UuPXx",
  "removeButtonIcon": "_6QXp1",
  "overlay": "yXH84",
  "shown": "RuVLK",
  "dark": "aB5Tg",
  "spinner": "YlLi7",
  "spin": "hDKG3"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
